import type { PlatformErrorAreas } from "$root/api/error-reporting";
import { Icon } from "@mdotm/shadcn/legacy/components";
import {
	Button,
	DropdownMenu,
	type DropdownMenuProps,
	type DropdownTriggerProps,
} from "@mdotm/shadcn/mdotm/components";
import { asyncStateFrom } from "@mdotm/utils/promise";
import { themeCSSVars } from "@mdotm/shadcn/legacy/themes";

function MoreActionsTrigger({ state, ...props }: DropdownTriggerProps) {
	return (
		<Button
			state={asyncStateFrom(state)}
			progressBar={false}
			palette="tertiary"
			size="small"
			className="px-0!"
			{...props}
		>
			<Icon icon="Vertical" size={24} color={themeCSSVars.palette_N400} />
		</Button>
	);
}

export function PageMoreActionsMenu(props: {
	actions: DropdownMenuProps["actions"];
	area: PlatformErrorAreas;
}): React.JSX.Element {
	return (
		<DropdownMenu
			actions={props.actions}
			Trigger={MoreActionsTrigger}
			extraTriggerProps={{ "data-qualifier": `PageMoreActionsMenu(${props.area})/Button` }}
		/>
	);
}
